// src/components/BoardPack/pages/LastTitle.jsx
import { useState } from "react";

// ✅ comment aur onCommentChange props se aata hai (BoardPack se)
// Isliye remount hone pe bhi value kabhi reset nahi hogi
function LastTitle({ page = null, hideInputField = false, comment = "", onCommentChange }) {
  const [title, setTitle] = useState(page?.title || "");
  const [isEditing, setIsEditing] = useState(true);

  const hasComment = comment.trim() !== "";

  const handleFieldBlur = (value) => {
    onCommentChange(value); // ✅ parent mein save
    if (value.trim() !== "") {
      setIsEditing(false);
    }
  };

  const handleFieldClick = () => {
    setIsEditing(true);
  };

  return (
    <div className="flex flex-col mt-24 gap-8">
      {/* Main Heading */}

      {page?.center ? (
        <>
        <div className="flex text-center items-center justify-center min-h-[720px] max-h-[720px]">
          <h1 className="text-5xl font-bold whitespace-nowrap">{page.title}</h1>
        </div>
        </>
      ) : (
        <>
          <div className="flex m-20 mt-8">
            <h1
              contentEditable={!hideInputField}
              suppressContentEditableWarning
              onBlur={(e) => setTitle(e.target.innerText)}
              className="text-blue-500 font-medium text-5xl outline-none cursor-text break-words max-w-4xl text-center whitespace-nowrap"
            >
              {title}
            </h1>
          </div>

          {/*
        Comments Section:
        - hideInputField=false (normal): textarea dikhao
        - hideInputField=true (export):
            → comment hai → text dikhao
            → comment nahi → kuch nahi dikhao
      */}
          {(!hideInputField || (hideInputField && hasComment)) && (
            <div className="w-full m-20 mt-8 max-w-md">
              {!hideInputField && isEditing ? (
                <div className="relative">
                  <textarea
                    defaultValue={comment}
                    onBlur={(e) => handleFieldBlur(e.target.value)}
                    placeholder="Comments here..."
                    autoFocus={comment !== ""}
                    rows="20"
                    className="w-full px-4 py-3 border-2 border-dashed border-blue-400 rounded-lg outline-none focus:border-solid focus:border-blue-600 text-lg shadow-sm bg-white focus:bg-white transition-all placeholder:text-gray-400 placeholder:italic resize-none"
                  />
                </div>
              ) : hasComment ? (
                <div
                  onClick={!hideInputField ? handleFieldClick : undefined}
                  className={`w-full px-4 py-3 rounded-lg border-2 border-transparent transition-all text-lg relative break-words whitespace-pre-wrap ${
                    !hideInputField ? "cursor-pointer hover:bg-blue-50 hover:border-blue-200" : ""
                  }`}
                >
                  {comment}
                </div>
              ) : null}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default LastTitle;
